import axios from "axios";
import { Workshop } from "./Domain";
import useGlobalPromise from "./useGlobalPromise";

export default () =>
	useGlobalPromise("ald_workshops", async () =>
		(await axios.get<Workshop[]>(`/api/workshops`)).data
	);
